import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Carrinho from "./Carrinho";
// import Carrinho from "./Carrinho";
import Fechamento from "./Fechamento";

export default function Index({ match }) {
  return (
    <div className="content-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/carrinho`} />
        <Route path={`${match.url}/carrinho`} component={Carrinho} />
        <Route path={`${match.url}/fechamento`} component={Fechamento} />
      </Switch>
    </div>
  );
}
